import { gql } from 'graphql-request';
import { CART_FRAGMENT } from './fragments';

/**
 * Creates a new Storefront Cart object.
 */
export const CART_CREATE = gql`
  mutation cartCreate($input: CartInput!, $country: CountryCode!)
  @inContext(country: $country) {
    cartCreate(input: $input) {
      cart {
        id
      }
      userErrors {
        code
        field
        message
      }
    }
  }
`;

/**
 * Updates Buyer Identity Information for A CartId
 */
export const UPDATE_CART_COUNTRY = gql`
  mutation cartBuyerIdentityUpdate(
    $buyerIdentity: CartBuyerIdentityInput!
    $cartId: ID!
  ) {
    cartBuyerIdentityUpdate(buyerIdentity: $buyerIdentity, cartId: $cartId) {
      userErrors {
        message
      }
    }
  }
`;

/**
 * Adds a merchandise line to the cart.
 */
export const CART_LINES_ADD = gql`
  mutation cartLinesAdd($lines: [CartLineInput!]!, $cartId: ID!, $country: CountryCode) @inContext(country: $country) {
    cartLinesAdd(lines: $lines, cartId: $cartId) {
      cart {
        ...cartFragment
      }
      userErrors {
        code
        field
        message
      }
    }
  }
  ${CART_FRAGMENT}
`;

/**
 * Removes one or more merchandise lines from the cart.
 */
export const CART_LINES_REMOVE = gql`
  mutation cartLinesRemove($cartId: ID!, $lineIds: [ID!]!, $country: CountryCode) @inContext(country: $country) {
    cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
      cart {
        ...cartFragment
      }
      userErrors {
        code
        field
        message
      }
    }
  }
  ${CART_FRAGMENT}
`;

/**
 * Updates one or more merchandise lines on a cart.
 */
export const CART_LINES_UPDATE = gql`
  mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!, $country: CountryCode) @inContext(country: $country) {
    cartLinesUpdate(cartId: $cartId, lines: $lines) {
      cart {
        ...cartFragment
      }
      userErrors {
        code
        field
        message
      }
    }
  }
  ${CART_FRAGMENT}
`;

export const CART_DISCOUNT_CODE_UPDATE = gql`
  mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!], $country: CountryCode) @inContext(country: $country) {
    cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
      cart {
        ...cartFragment
      }
      userErrors {
        code
        field
        message
      }
    }
  }
  ${CART_FRAGMENT}
`;

/**
 * Updates the attributes on a cart.
 */
export const CART_ATTRIBUTES_UPDATE = gql`
  mutation cartAttributesUpdate($attributes: [AttributeInput!]!, $cartId: ID!, $country: CountryCode) @inContext(country: $country) {
    cartAttributesUpdate(attributes: $attributes, cartId: $cartId) {
      cart {
        ...cartFragment
      }
      userErrors {
        code
        field
        message
      }
    }
  }
  ${CART_FRAGMENT}
`;

/**
 * Updates the note on the cart.
 */
export const CART_NOTE_UPDATE = gql`
  mutation cartNoteUpdate($cartId: ID!, $note: String!, $country: CountryCode) @inContext(country: $country) {
    cartNoteUpdate(cartId: $cartId, note: $note) {
      cart {
        ...cartFragment
      }
      userErrors {
        code
        field
        message
      }
    }
  }
  ${CART_FRAGMENT}
`;
